var _style, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAwake5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 156 156",
    style: {
      enableBackground: "new 0 0 156 156"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.8,1.1c5.8,0,10.5,4.7,10.5,10.5v132c0,5.8-4.7,10.5-10.5,10.5h-132c-5.8,0-10.5-4.7-10.5-10.5v-132 C1.3,5.8,6,1.1,11.8,1.1H143.8 M143.8-0.4h-132c-6.6,0-12,5.4-12,12v132c0,6.6,5.4,12,12,12h132c6.6,0,12-5.4,12-12v-132 C155.8,5,150.4-0.4,143.8-0.4L143.8-0.4z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M77.8,145.4C40.4,145.4,10,115,10,77.6C10,40.3,40.4,9.9,77.8,9.9s67.7,30.4,67.7,67.7C145.5,115,115.1,145.4,77.8,145.4z  M77.8,14.6c-34.7,0-63,28.3-63,63c0,34.7,28.3,63,63,63c34.7,0,63-28.3,63-63C140.8,42.9,112.5,14.6,77.8,14.6z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 81.2,
    cy: 113.4,
    rx: 20.3,
    ry: 5
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.9,
    cy: 66.6,
    rx: 6.8,
    ry: 7.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "st0",
    cx: 99.7,
    cy: 66.1,
    rx: 3.6,
    ry: 4
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 99.4,
    cy: 66.6,
    rx: 6.8,
    ry: 7.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwake5);
export default __webpack_public_path__ + "static/media/Awake5.204576e8123c6a76d7185e83e1957571.svg";
export { ForwardRef as ReactComponent };